import { MFPClaimPaymentStatus } from '@module-claims/enums/mfp-claim.enum';
import { SortDescriptor, FilterDescriptor } from '@progress/kendo-data-query';
import { tryGetISODateString } from '@utils-global/date-time';

export interface MFPClaim {
  _id: string;
  record_id?: string | null;
  internal_claim_number?: string | null;
  xref_internal_claim_number?: string | null;
  process_date?: string | null;
  transaction_code?: string | null;
  source_of_coverage?: string | null;
  date_of_service?: string | null;
  service_provider_identifier?: string | null;
  service_provider_identifier_qualifier?: string | null;
  service_reference_number?: string | null;
  prescriber_id?: string | null;
  prescriber_id_qualifier?: string | null;
  fill_number?: string | number | null;
  service_identifier?: string | null;
  quantity_dispensed?: number | null;
  number_of_days_supply?: number | null;
  claim_indicator_340b?: string | null;
  contract_number?: string | null;
  wac_per_unit_dos_partd?: number | null;
  mfp_per_unit_dos_partd?: number | null;
  standard_default_refund_amount?: number | null;
  service_provider_payment_preference?: string | null;
  date_claim_received_from_mtf?: string | null;
  date_claim_updated_last_by_mtf?: string | null;
  payment_due_date?: string | null;
  payment?: string | null;
  payment_invoice_number?: string | null;
  debit_due?: string | null;
  debit_received_date?: string | null;
  debit_invoice?: string | null;
  identified_340b?: number | null;
  id340b?: string | null;
  status_340b?: string | null;
  payment_status?: string | null;
}

export interface MFPClaimsGetParams {
  customerId: string;
  take: number;
  skip: number;
  sort: SortDescriptor[];
  filters: FilterDescriptor[];
}

export interface MFPClaimsUpdateParams {
  customerId: string;
  idList: string[];
  paymentStatus: MFPClaimPaymentStatus;
}

export function transformMFPClaim(claim: MFPClaim): MFPClaim {
  return {
    ...claim,
    // TODO: Omit transformation of full timestamps
    process_date: claim.process_date && tryGetISODateString(claim.process_date),
    date_of_service:
      claim.date_of_service && tryGetISODateString(claim.date_of_service),
    payment_due_date:
      claim.payment_due_date && tryGetISODateString(claim.payment_due_date),
    payment: claim.payment && tryGetISODateString(claim.payment),
    debit_due: claim.debit_due && tryGetISODateString(claim.debit_due),
    debit_received_date:
      claim.debit_received_date &&
      tryGetISODateString(claim.debit_received_date)
  };
}
